export default function ConfirmModal({ title, message, confirmLabel = 'Delete', onConfirm, onCancel, danger = true }) {
  return (
    <div className="hv-modal-overlay" onClick={onCancel}>
      <div className="hv-modal" style={{ maxWidth: '420px' }} onClick={e => e.stopPropagation()}>

        <div className="hv-modal-header" style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
          {danger && (
            <div style={{
              width: '36px', height: '36px', borderRadius: '8px',
              background: 'var(--hv-red-bg)', display: 'flex', alignItems: 'center',
              justifyContent: 'center', flexShrink: 0,
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--hv-red)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                <path d="M10 11v6M14 11v6" />
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
              </svg>
            </div>
          )}
          <div>
            <div className="hv-modal-title">{title}</div>
            {message && (
              <p style={{ margin: '6px 0 0', fontSize: '13.5px', color: 'var(--hv-text-secondary)', lineHeight: '1.5' }}>
                {message}
              </p>
            )}
          </div>
        </div>

        <div className="hv-modal-footer">
          <button className="hv-btn hv-btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button
            className="hv-btn"
            onClick={onConfirm}
            style={{
              background: danger ? 'var(--hv-red)' : 'var(--hv-accent)',
              color: '#fff',
            }}
          >
            {confirmLabel}
          </button>
        </div>

      </div>
    </div>
  )
}